import React from 'react';
import { Typography } from 'antd';

import { ButtonBack } from '../../../shared/ui/Button/ButtonBack';
import { ChatAvatar } from '../features/ChatList/components/ChatAvatar';
import { useAppDispatch, useAppSelector } from '../../../store';
import { selectAnalyticsSelection } from '../store/analyticSelectorSlice';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../store/analyticFiltersSlice';

export const ChatBackButton = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const { current } = useAppSelector(selectAnalyticsSelection);

    const dispatch = useAppDispatch();

    return filters.chat ? (
        <ButtonBack
            onClick={() => {
                dispatch(
                    updateFilters({
                        ...filters,
                        chat: null,
                        offset: 0,
                    })
                );
            }}
        >
            <ChatAvatar {...current} />
        </ButtonBack>
    ) : (
        <Typography.Text strong>Все сообщества</Typography.Text>
    );
};
